var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"mt-15"}),_c('v-col',{staticClass:"mt-15 pa-5",attrs:{"cols":"12","xl":"5","lg":"5","md":"5","sm":"12","xs":"12"}},[_c('MainCalendar')],1),_c('v-col',{attrs:{"cols":"3"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }